<template>
    <div id="stockTaking">
        <el-row>
            <el-col>
                <el-button type="success" size="small" @click.stop="newInventoryClick" v-if="onoffManager"
                           style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size: 13px">
                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                    添加
                </el-button>
            </el-col>
            <el-col>
                <el-table
                        :header-cell-style="{'color':'black','font-size':'15px'}"
                        :data="tableData"
                        border
                        style="width: 100%;margin-top: 10px"
                        stripe>
                    <el-table-column
                            align="center"
                            type="index"
                            label="序号"
                            width="60px">
                    </el-table-column>
                    <el-table-column
                            prop="sku_name"
                            sortable
                            label="单品"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="unit_name"
                            sortable
                            label="单位"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="opening_stock"
                            sortable
                            label="本月期初库存"
                            width="150"
                    >
                    </el-table-column>
                    <el-table-column
                            width="150"
                            prop="stock_quantity"
                            sortable
                            label="本月最新库存">
                    </el-table-column>
                    <el-table-column
                            width="140"
                            prop="expiring_items"
                            sortable
                            label="临期商品数">
                    </el-table-column>
                    <el-table-column
                            width="140"
                            prop="suggested_order"
                            sortable
                            label="建议订货数">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label-class-name="stockTaking_table_cell"
                            label="操作"
                            :width="onoffManager ? 160:90"
                            style="color: #3b99f7"
                    >
                        <template slot-scope="scope">
                            <div style="text-align: center;width: 100%;height: 100%">
                                <el-button
                                        style="display: inline-block"
                                        type="warning" size="small"
                                        @click="handleDetail(scope.row)">详情
                                </el-button>
                                <el-button
                                        v-if="onoffManager"
                                        style="display: inline-block"
                                        type="danger" size="small"
                                        @click="deleteHandleDetail(scope.row)">删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </el-col>
        </el-row>
        <!--        库存采集-->
        <el-dialog
                :visible.sync="inventoryBool"
                width="700px"
                :show-close="false"
                @close="closeInventoryModel"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">库存盘点
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" v-if="onoffManager" @click.stop="inputEditInventoryInfo">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="inventoryBool = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="inventory" style="margin-top: 20px;">
                    <el-form ref="formInventory" :model="addInventory" label-width="20%" style="margin-left: 110px" :disabled="disabled" hide-required-asterisk="false">
                        <el-form-item label="单品" class="stockTaking_star" :rules="[{required:true,message:'单品不能为空'}]" prop="sku_id">
                            <el-select v-model="addInventory.sku_id" placeholder="请选择单品" value-key="sku_id"
                                       @change="choseSku" style="width:70%;margin-left: 5%" clearable filterable>
                                <el-option
                                        v-for="item in skuList"
                                        :key="item.sku_id"
                                        :label="item.sku_name"
                                        :value="item.sku_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包装单位">
                            <el-input v-model="addInventory.unit_name" placeholder=""  disabled style="width: 70%;
                            margin-left: 5%"></el-input>
                        </el-form-item>
                        <el-form-item label="本月期初库存" >
                            <el-input-number type="number" v-model="addInventory.opening_stock" placeholder="请填写本月的期初库存（选填）" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="本月最新库存" class="stockTaking_star" :rules="[{required:true,message:'本月最新库存不能为空'}]" prop="stock_quantity">
                            <el-input-number type="number" v-model="addInventory.stock_quantity" placeholder="请填写本月的最新库存（必填）" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="临期商品数量">
                            <el-input-number type="number" v-model="addInventory.expiring_items" placeholder="请填写临期的商品数量（选填）" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="建议订货数量">
                            <el-input-number type="number" v-model="addInventory.suggested_order" placeholder="请填写建议的订货数量（选填）" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <!--                        <el-form-item label="说明">-->
                        <!--                            <el-input-->
                        <!--                                    type="textarea"-->
                        <!--                                    :autosize="{ minRows: 4}"-->
                        <!--                                    placeholder="请输入说明"-->
                        <!--                                    v-model="addInventory.comments"-->
                        <!--                            style="width: 70%">-->
                        <!--                            </el-input>-->
                        <!--                        </el-form-item>-->
                    </el-form>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../APIService/http'
    import pagination from '../../../../components/pagination'
    import moment from 'moment'
    export default {
        name: "stockTaking",
        props:{
            data:{
                type: Object,
                default: {}
            },
        onoffManager:{
            type:Boolean,
            default:true
        }
        },
        data(){
            return{
                tableData:[],
                addInventory:{},
                skuList:[],
                inventoryBool:false,
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                disabled:false,
                onoffManager:true,
            }
        },
        components: {
            pagination
        },
        created () {
            this.init()
            this.getSkuList()
            if(!this.onoffManager){
                this.disabled = true
            }
        },
        mounted () {
            let user = this.$store.getters.getUser

            if(this.onoffManager){
                if (this.data.created_by === user.user_id) {
                    this.disabled = false
                    this.onoffManager =true
                }else {
                    this.disabled = true
                    this.onoffManager =false
                }
            }
        },
        methods: {
            choseSku(item){
                for (let i =0;i<this.skuList.length;i++){
                    if (this.skuList[i].sku_id === item) {
                        this.addInventory.unit_name = this.skuList[i].unit_name
                        this.addInventory.product_id = this.skuList[i].product_id
                        break
                    }
                }
            },
            closeInventoryModel(){
                this.addInventory = {}
                this.$refs["formInventory"].resetFields()
            },
            inputEditInventoryInfo(){
                this.$refs["formInventory"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.editInventoryInfo()
                    }
                })
            },
            editInventoryInfo(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = this.addInventory
                    data.tenant_id = user.tenant_id
                    data.user_id = user.user_id
                    data.inspection_id = this.data.activity_id
                    data.store_id = this.data.store_id
                    http.post('/wapi/StoreTour/editInventoryByStore',data).then(res=>{
                        if (res.success === true){

                            this.init()
                            this.$message({
                                type: 'success',
                                message:'保存成功'
                            })

                            loading.close()
                            this.inventoryBool = false
                        } else {
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            handleDetail(item){
                this.inventoryBool = true
                this.addInventory = JSON.parse(JSON.stringify(item))
            },
            deleteHandleDetail(item){
                try {
                    this.$confirm('此操作将删除该库存盘点, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        let user = this.$store.getters.getUser
                        let data = item
                        data.tenant_id = user.tenant_id
                        data.user_id = user.user_id
                        data.inspection_id = this.data.activity_id
                        data.store_id = this.data.store_id

                        http.post('/wapi/StoreTour/deleteInventoryByStore',data).then(res=>{
                            if (res.success === true){
                                this.init()
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                            }
                        })


                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                }catch (e) {

                }

            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        store_id : this.data.store_id,
                        inspection_id : this.data.activity_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                    }
                    await http.post('/wapi/StoreTour/getStockTakingList',data).then(res=>{
                        this.page.total = res.data.arrayCount
                        this.tableData =  res.data.result
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            // 获取单品
            getSkuList(){
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    http.post('/wapi/StoreTour/getSkuList',data).then(res=>{
                        if(res.success === true){

                            this.skuList = res.data
                        }
                    })
                }catch (e) {
                    return e
                }
            },

            newInventoryClick(){
                this.inventoryBool=true
            },
        }
    }
</script>

<style scoped>
    #inventory >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #stockTaking >>> .el-form-item__error{
        margin-left: 5%;
    }
    #stockTaking >>> .stockTaking_table_cell {
        color: #2b92fa !important;
    }
    #stockTaking >>> .stockTaking_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #stockTaking >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #stockTaking >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #stockTaking >>> .el-button--danger {
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    #stockTaking >>> .el-button--danger:hover {
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    #stockTaking >>> .el-input__inner::placeholder{
        text-align: left;
    }
    #stockTaking >>> .el-input-number.is-controls-right .el-input__inner {
        text-align: left;
    }
    #stockTaking >>> .el-button--small {
        padding: 9px 12px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/stockTaking.vue